import React from "react";
import { connect } from "react-redux";
import { OnboardLayout } from "../../Layout";
import { CaptureInfo, Sidebar } from "../../components/Onboard";

class OnboardProfileScreen extends React.Component {
  state = {
    isLoading: false,
  };

  render() {
    return (
      <OnboardLayout>
        <CaptureInfo />
        <Sidebar />
      </OnboardLayout>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(OnboardProfileScreen);
